import { Col, FormGroup, Label, Row } from "reactstrap";
import { ErrorMessage, useFormikContext } from "formik";
import CommonFileUpload from "./CommonFileUpload";

interface BlogSEO {
  seoTitle: string;
  seoDescription: string;
  seoImageAlt: string;
  schemaJson: string[];
  image: File | null;
  imageUrl?: string;
}

const SeoImageUpload = () => {
  const { values } = useFormikContext<BlogSEO>();

  return (
    <Row className="mt-4">
      <Col>
        <FormGroup>
          <Label check>SEO / OG Image</Label>
          <CommonFileUpload
            name="image" // ✅ EXACT backend key
            existingImageUrl={values.imageUrl}
          />
          <ErrorMessage name="image" component="div" className="text-danger" />
        </FormGroup>
      </Col>
    </Row>
  );
};

export default SeoImageUpload;
